import { Link } from 'react-router-dom';
import { contactInfo } from '@/mocks/codesajan';

const footerLinks = [
  {
    title: 'Servicios',
    links: [
      { label: 'Consultar Deuda', href: '/consultar-deuda' },
      { label: 'Pagar Agua', href: '/pagar' },
      { label: 'Lecturación', href: '/lecturacion' },
      { label: 'Reclamos', href: '/reclamos' },
    ],
  },
  {
    title: 'Institución',
    links: [
      { label: 'Nosotros', href: '/nosotros' },
      { label: 'Servicios', href: '/servicios' },
      { label: 'Cobertura', href: '/cobertura' },
      { label: 'Contacto', href: '/contacto' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Términos de Uso', href: '/terminos' },
      { label: 'Privacidad', href: '/privacidad' },
      { label: 'Normativa', href: '/normativa' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white/80">
      {/* CTA Banner */}
      <div className="bg-primary-800">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-8 md:py-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-1">
                ¿Necesitás consultar tu deuda?
              </h3>
              <p className="text-sm text-white/70">
                Accedé a tu información de forma rápida y segura las 24 horas del día.
              </p>
            </div>
            <Link
              to="/consultar-deuda"
              className="px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white font-semibold rounded-lg transition-colors whitespace-nowrap text-sm"
            >
              Consultar Ahora
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Brand column */}
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/9c1b68bd-ebce-43c5-9051-a010ad0fba29_compressed_logotipo-comite-de-aguaxcf.webp"
                alt="CODESAJAN"
                className="h-10 w-10 object-contain"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-heading font-bold text-sm tracking-wide text-white">
                  CODESAJAN
                </span>
                <span className="text-[10px] text-white/50 tracking-wider">
                  TARIJA - BOLIVIA
                </span>
              </div>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed mb-5 max-w-sm">
              Comité de Servicios de Agua San Jacinto Norte Zona Oeste. Personería Jurídica N° 056/2011 — Gobernación de Tarija.
            </p>
            <div className="flex items-center gap-3">
              <a
                href={contactInfo.social.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-accent-500 flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((section) => (
            <div key={section.title} className="lg:col-span-2">
              <h4 className="font-heading font-semibold text-sm text-white mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-white/60 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact column */}
          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-sm text-white mb-4">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-accent-400 mt-0.5 text-sm w-4 h-4 flex items-center justify-center shrink-0"></i>
                <span className="text-sm text-white/60">{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-phone-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center shrink-0"></i>
                <span className="text-sm text-white/60">{contactInfo.phoneMobile}</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-time-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center shrink-0"></i>
                <span className="text-sm text-white/60">{contactInfo.hours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-xs text-white/40">
              &copy; {new Date().getFullYear()} CODESAJAN. Todos los derechos reservados.
            </p>
            <p className="text-xs text-white/40">
              San Jacinto Norte Zona Oeste — Tarija, Bolivia
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}